


interface User {
  piEmail: string;
  email: string;
}

import { defineComponent, ref, PropType, computed, watch, onMounted  } from "vue";
import moment from "moment";
import { Field } from "vee-validate";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { useStore} from "vuex"
import { useRouter} from "vue-router"
import { useToast } from "vue-toastification";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "table-action",
  components: {

  },
  methods: {
      
  },
  props: {
    
  },
  
  setup(props) { 
    const store = useStore();
    const toast = useToast();
    const router = useRouter();
    const route = useRoute();

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const gotToNotificationAlert = function() {
        router.push({ name: "notification-alert" });
    }
    
    const info = computed(() => {
      let infow = store.getters.currentNotificationAlertSuscription?.value ||   store.getters.currentNotificationAlertSuscription;
      try {
        if (infow != null &&  infow["data"] != null) {
          let rta = infow?.data?.split("\n");
          if (rta.length > 3) {
            
            return rta[rta.length -3];
          }
        }
      } catch(e) {console.log(e);}
      return "";
    });
    
    const size = computed(() => {
      let infow = store.getters.currentNotificationAlertSuscription?.value ||   store.getters.currentNotificationAlertSuscription;
      try {
        if (infow != null &&  infow["data"] != null ) {
          let rta = infow?.data?.split("\n");
          
          if (rta.length > 3 && infow["updated"] == true) {
            store.dispatch(Actions.GET_IRB_NOTIFICATION_ALERT_PENDING, {params:{}});
            infow.updated = false;
            store.commit(Mutations.SET_IRB_SUSCRIBE_NOTIFICATION_ALERT, infow);
            let lng = rta.length;

            if(rta[lng-4].includes("event: message")) {
              toast.success("You have new updates", {
                timeout: 2000
              });
            }
          }
          return rta.length;
        }
      } catch(e) {console.log(e);}
      return "0";
    });


    const size2 = computed(() => {
      console.log(store.getters.currentNotificationAlertsPending);
      return store.getters.currentNotificationAlertsPending;
    });

    
    const recordsPerPage = computed(() => {
      return "true";
    });
    
    watch(
      () => route?.path,
      () => {
        store.dispatch(Actions.GET_IRB_SUSCRIBE_NOTIFICATION_ALERT, "3");
        store.dispatch(Actions.GET_IRB_NOTIFICATION_ALERT_PENDING, {params:{}});
      }
    );

    onMounted( ()=> {
      store.dispatch(Actions.GET_IRB_NOTIFICATION_ALERT_PENDING, {params:{}});
    });

    

    return {
      recordsPerPage,
      info,
      size,
      toast,
      size2,
      gotToNotificationAlert,
    };
  },
});
